var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9959 13.399V13.3985H15.9999V8.66207C15.9999 6.34497 15.3819 4.56006 12.0259 4.56006C10.4125 4.56006 9.32986 5.27467 8.88786 5.95215H8.84119V4.77638H5.65918V13.3985H8.97252V9.12915C8.97252 8.00504 9.23652 6.91806 10.9612 6.91806C12.6605 6.91806 12.6859 8.20091 12.6859 9.20125V13.399H15.9959Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.26416 4.77686H3.58154V13.399H0.26416V4.77686Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.92133 0.484253C0.860663 0.484253 0 1.17898 0 2.03515C0 2.89133 0.860663 3.60059 1.92133 3.60059C2.98199 3.60059 3.84265 2.89133 3.84265 2.03515C3.84198 1.17898 2.98132 0.484253 1.92133 0.484253V0.484253Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.563f4390611629d8b223e3284cc20f50.svg";
export { ForwardRef as ReactComponent };